import React from 'react';
import { countriesTooltip, getCountriesArray } from '../functions/Functions';

interface CountryListWithTooltipProps {
    countries: string[];
    t: any;
    nbVisibleCountries?: number;
    tooltipPlacement?: 'top' | 'right' | 'bottom' | 'left';
    style?: React.CSSProperties;
    className?: string;
}

export const CountryListWithTooltip: React.FC<CountryListWithTooltipProps> = ({
    countries,
    t,
    nbVisibleCountries = 1,
    tooltipPlacement = 'right',
    style,
    className = '',
}) => {
    if (!countries || countries.length === 0) {
        return null;
    }

    return (
        <div className={`d-flex align-items-center ${className}`} style={style}>
            {getCountriesArray(countries, t, nbVisibleCountries)}
            <div className="mb-0 ml-1">
                {countries.length > nbVisibleCountries
                    ? countriesTooltip(countries.slice(nbVisibleCountries), t, tooltipPlacement)
                    : ''}
            </div>
        </div>
    );
};
